export function unescapeHTML(str: string): string {
  const escaped = atob(str)
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'")
    .replace(/&amp;/g, "&");
  return decodeURIComponent(escaped);
}
